import React from 'react'
import {connect} from 'react-redux'
import CustomerForm from "./CustomerForm";
import {formValueSelector} from "redux-form";
import {AuthorizationUtils} from "../../../utils/AuthorizationUtils";
import RequestTemplate from "../../../common/RequestTemplate";
import {useCustomer} from "../SubformsActions";
import {FormUtils} from "../../../utils/FormUtils";

let CustomerContainer = props => {
  const {onSubmit, onCancel, windowSize, state, useCustomer} = props;

  const getRawFormValues = () => {
    const selector = formValueSelector('customer');
    const formValues = selector(
      state, 'email', 'merchantCustomerId'
    );
    return FormUtils.getNotEmptyValues(formValues);
  };

  const getOrderRequest = () => {
    const formValues = getRawFormValues();
    return <RequestTemplate
      httpMethod={'POST'}
      url={`${state.app.config.api.baseUrl}/customers`}
      authorizationHeader={
        AuthorizationUtils.base64(state.app.config.environment.merchantId, state.app.config.environment.apiKey)
      }
      body={formValues}
    />
  };

  const useLastCreated = () => {
    useCustomer(state.subforms.customerResponse.result.customerId);
    onCancel();
  };

  const getOrderResponse = () => {
    if (state.subforms.customerResponse.error === null && state.subforms.customerResponse.result === null) {
      return '';
    }
    if (state.subforms.customerResponse.error) {
      return <div>
        <p className="alert alert-danger">Error while creating a customer</p>
        <pre>{JSON.stringify(state.subforms.customerResponse.error, null, 2)}</pre>
        <div className="hr-line-dashed"></div>
      </div>;
    }
    return <div>
      <p className="alert alert-success">The customer has been created successfully.</p>
      <pre className="">{JSON.stringify(state.subforms.customerResponse.result, null, 2)}</pre>
      <div>
        <button type="button" className="btn btn-primary btn-block" onClick={useLastCreated}>
          <span className="btn-text">Use this customer</span>
        </button>
      </div>
      <div className="hr-line-dashed"></div>
      <h4 className="text-center">... or create another ...</h4>
    </div>;
  };

  return (
    <div className="inmodal hmodal-danger">
      <div className="color-line"></div>
      <div className="modal-header modal-header-padding">
        <h4 className="modal-title">Create a customer</h4>
      </div>
      <div className="modal-body" style={{
        maxHeight: (windowSize.height * 0.7) + 'px',
        maxWidth: (windowSize.width * 0.8) + 'px',
        overflow: 'scroll'
      }}>

        <div className="col-lg-6 col-md-12 col-xs-12">
          <div className="modal-body">
            {getOrderResponse()}
          </div>
          <CustomerForm cancel={onCancel} onSubmit={onSubmit}/>
        </div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          {getOrderRequest()}
        </div>
      </div>
    </div>
  );
};

CustomerContainer.propTypes = {};

const mapStateToProps = (state) => ({
  state: state
});

export default connect(
  mapStateToProps,
  {useCustomer}
)(CustomerContainer);



// WEBPACK FOOTER //
// ./src/order/subforms/customer/CustomerContainer.js